import React from 'react'
import {Router, route, indexRoute, hashHistory} from 'react-router'




export default class License extends React.Component {
  constructor (props) {
      super(props)
  }

  render () {
    return <div id="content">
              <embed src="TERMS OF SERVICE AGREEMENT.pdf" width="100%" min-height="100%" height="2100px" internalinstanceid="50" title=""/>
            </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/License.jsx